module.exports = __webpack_public_path__ + "static/media/rockall-logo.3e81c7d9.svg";